export const pathname = () => window.location.pathname;
export const href = () => window.location.href;
export const search = () => window.location.search;
export const origin = () => window.location.origin;
